import React, { createContext, useState, ReactNode, useContext } from "react";
import { UserDetails } from "@/types/user";

export interface UserContextType {
  currentUser: UserDetails | null;
  setCurrentUser: (user: UserDetails | null) => void;
  lastAvatarUpdate: number;
  refreshAvatar: () => void;
}

const defaultUserContext: UserContextType = {
  currentUser: null,
  setCurrentUser: () => {},
  lastAvatarUpdate: 0,
  refreshAvatar: () => {},
};

export const UserContext = createContext<UserContextType>(defaultUserContext);

export function UserProvider({ children }: { children: ReactNode }) {
  const [currentUser, setCurrentUser] = useState<UserDetails | null>(null);
  const [lastAvatarUpdate, setLastAvatarUpdate] = useState<number>(Date.now());

  const refreshAvatar = () => {
    setLastAvatarUpdate(Date.now());
  };

  return (
    <UserContext.Provider
      value={{
        currentUser,
        setCurrentUser,
        lastAvatarUpdate,
        refreshAvatar,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

export function useUserContext() {
  const context = useContext(UserContext);
  
  if (context === undefined) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  
  return context;
}